import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";

import "../../../Style/hypperViewStyle.css";
import { formatDate, getRecords } from "../../../services/api.service";
import CustomForm from "../../../custom/Forms/CustomForm";

const InstallationLogView = ({ args }) => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const [loadingData, setLoadingData] = useState(false);

  const [logData, setLogData] = useState([]);
  const [expandedInwardLogs, setExpandedInwardLogs] = useState({});
  const [expandedMakeItems, setExpandedMakeItems] = useState({});
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    if (id) {
      getInstallationLogs(id);
    }
  }, [id]);

  const getInstallationLogs = async (Id) => {
    let payload = {
      modelName: "installation_logs",
      whereCondition: {
        installation_id: Id,
      },
    };

    const responseData = await getRecords(payload, "/getRecords");
    if (responseData.code == 1) {
      setLoadingData(false);
      setLogData(responseData?.data);
    } else {
      setLoadingData(false);
    }
  };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  const filteredItems =
    logData?.filter((item) =>
      item?.outward_no?.toLowerCase().includes(searchKeyword.toLowerCase())
    ) || [];
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
  };
  const toggleInwardLog = (index) => {
    setExpandedInwardLogs((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleMakeItem = (key) => {
    setExpandedMakeItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <CustomForm
      title="Installation Log"
      id={id}
      noBackButton
      noSubmitButton
      loadingData={loadingData}
    >
      <Row className="">
        <Col lg={12}>
          <div
            className="table mt-2"
            style={{
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "500px",
              width: "100%",
              scrollBehavior: "smooth",
              scrollbarWidth: "thin",
              msOverflowStyle: "none",
              zIndex: 0,
            }}
          >
            <table className="table">
              <thead
                style={{
                  backgroundColor: "#8AC1E8",
                  position: "sticky",
                  top: "0px",
                }}
              >
                <tr style={{ borderBottom: "1px solid black" }}>
                  <th style={{ whiteSpace: "nowrap" }}>Sr No</th>
                  <th style={{ whiteSpace: "nowrap" }}>Installation No</th>
                  <th style={{ whiteSpace: "nowrap" }}>Assigned By</th>
                  <th style={{ whiteSpace: "nowrap" }}>Created By</th>
                  <th style={{ whiteSpace: "nowrap" }}>Approval By</th>
                  <th style={{ whiteSpace: "nowrap" }}>Installation Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Status</th>
                  <th style={{ whiteSpace: "nowrap" }}>View</th>
                </tr>
              </thead>
              <tbody>
                {logData && logData.length > 0 ? (
                  logData.map((log, logIndex) => {
                    let serialNumber = 1;

                    return (
                      <React.Fragment key={logIndex}>
                        <tr>
                          <td>{logIndex + 1}</td>
                          <td>{log.installation_no || "-"}</td>

                          <td>{log.created_by || "-"}</td>

                          <td>{log.created_by}</td>
                          <td>{log.assigned_to || "-"}</td>
                          <td>{formatDate(log.installation_date)}</td>
                          <td>{log.status || "-"}</td>
                          <td>
                            <Link
                              className="text-primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleInwardLog(logIndex);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className={`mdi mdi-${
                                  expandedInwardLogs[logIndex]
                                    ? "minus"
                                    : "plus"
                                } font-size-22`}
                              ></i>
                            </Link>
                          </td>
                        </tr>

                        {expandedInwardLogs[logIndex] && (
                          <>
                            <tr
                              style={{
                                backgroundColor: "#E5F1FC",
                                fontWeight: "900",
                              }}
                            >
                              <th></th>
                              <th></th>
                              <th>Sr No</th>
                              <th>Item Code</th>
                              <th>Item Desc</th>
                              <th>QTY</th>
                              <th></th>
                              <th></th>
                            </tr>
                            {console.log("logitems", log.items)}

                            {log.items.map((item, itemIndex) => {
                              // Create a unique key by combining logIndex and itemIndex
                              const uniqueItemKey = `${logIndex}-${itemIndex}`;

                              return (
                                <React.Fragment key={uniqueItemKey}>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td>{serialNumber++}</td>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          cursor: item?.is_make_item
                                            ? "pointer"
                                            : "default",
                                        }}
                                        title={item?.item_code || "N/A"}
                                      >
                                        <span>{item?.item_code || "N/A"}</span>

                                        {item?.is_make_item && (
                                          <Link
                                            className="text-primary"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleMakeItem(uniqueItemKey);
                                            }}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <i
                                              className={`mdi mdi-chevron-${
                                                expandedMakeItems[uniqueItemKey]
                                                  ? "up"
                                                  : "down"
                                              } font-size-18`}
                                            ></i>
                                          </Link>
                                        )}
                                      </div>
                                    </td>
                                    <td>{item.item_description}</td>
                                    <td>
                                      {item?.is_make_item
                                        ? "-"
                                        : item.buy_item_details[0]
                                            .installed_qty}
                                    </td>

                                    <td></td>
                                    <td></td>
                                  </tr>

                                  {expandedMakeItems[uniqueItemKey] &&
                                    item.buy_item_details.map(
                                      (buyItem, buyItemIndex) => (
                                        <tr key={buyItemIndex}>
                                          <td></td>
                                          <td></td>
                                          <td style={{ paddingLeft: "30px" }}>
                                            {`${serialNumber - 1}.${
                                              buyItemIndex + 1
                                            }`}
                                          </td>
                                          <td>{buyItem.buy_item_code}</td>
                                          <td>
                                            {buyItem.buy_item_description}
                                          </td>
                                          <td>{buyItem.installed_qty}</td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                      )
                                    )}
                                </React.Fragment>
                              );
                            })}
                          </>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default InstallationLogView;
